export default __webpack_public_path__ + "static/media/Indian_Institute_of_Management_Udaipur_Logo.c9d5d5de.png";